import { ReactNode, createContext } from "react";
import { api } from "../Api/ApiService";
import { AxiosError } from "axios";
import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

interface IAppContext {
  login: (email: string, senha: string) => Promise<void>;
  logOut: () => void;
}

interface ILoginResponseData {
  expiretion: Date;
  token: string;
  user_infor: {
    email: string;
    role: string;
  };
}

interface IContexProvider {
  children: ReactNode;
}

export const AppConText = createContext({} as IAppContext);

const ContextProvider = ({ children }: IContexProvider) => {
  const navigator = useNavigate();
  const toast = useToast();

  async function login(email: string, senha: string) {
    try {
      const result = await api.post<ILoginResponseData>(
        `/login?token=${process.env.REACT_APP_TOKEN_API}`,
        {
          email,
          senha,
        }
      );

      if (result.data.token && result.data.token !== undefined) {
        if (result.data.user_infor.role === "tutor") {
          localStorage.setItem(
            String(process.env.REACT_APP_LOCAL_KEY),
            result.data.token
          );

          navigator("/home");
        } else {
          localStorage.setItem(
            String(process.env.REACT_APP_LOCAL_KEY),
            result.data.token
          );

          navigator("/animais");
        }
      }

      toast({
        title: "Login realizado com sucesso",
        description: "Seja bem-vindo ao Nina",
        status: "success",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    } catch (error: AxiosError | any) {
      console.log(error);
      toast({
        title: "Error",
        description: error.response ? error.response.data : "Error interno",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  function logOut() {
    localStorage.removeItem(String(process.env.REACT_APP_LOCAL_KEY));
    localStorage.clear();
    navigator("/", { replace: true });
  }

  return (
    <AppConText.Provider
      value={
        {
          login,
          logOut,
        } as IAppContext
      }
    >
      {children}
    </AppConText.Provider>
  );
};

export default ContextProvider;
